import { render } from "./EditDescriptionComponentXML.vue?vue&type=template&id=b1351872"
import script from "./EditDescriptionComponentXML.vue?vue&type=script&lang=js"
export * from "./EditDescriptionComponentXML.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__